import { createOrEditItem, deleteItem } from './form'

export const deleteAlert = id => async dispatch =>
  await dispatch(
    deleteItem({
      endpoint: `operationAlerts/${id}`,
      successMessage: 'Alert was successfully Deleted',
    })
  )
